import { supabaseClient } from "supabase";

export const login = async (email: string, password: string) => {
  const { data, error } = await supabaseClient.auth.signInWithPassword({
    email,
    password,
  });

  return { error: error || null, data };
};
